module.exports = __webpack_public_path__ + "img/model_46_ug.2f7ed753.jpg";